import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const AddToCartIcon: FC<IconProps> = ({ width = 32, height = 30, ...rest }) => (
  <Icon type="AddToCart" width={width} height={height} alt="AddToCart" {...rest} />
)
